String.prototype.assignParams = function(params) {
  let val = this;
  for (let key in params) val = val.replace(`{${key}}`, params[key]);
  for (let key in params) val = val.replace(`{${key}?}`, params[key]);
  return val;
}

class Hateoas {
  constructor() {
    this.routes = {};
  }

  url(route, params) {
    let url = this.routes[route];

    if (params) {
      url = url.assignParams(params);
    }

    return url;
  }
}

export default new Hateoas();